import React, { createContext, useContext, useMemo, useState } from 'react';

/**
 * Estado TRANSITÓRIO "a modal de update está NA TELA agora" — não é "update pendente"
 * (que duraria a sessão). Fonte única entre o VersionChecker (escreve) e o Amplifique
 * (lê, pra não colar o survey NPS na modal). Escopo estreito: só esses dois consomem,
 * então mudar o flag re-renderiza só os consumidores, não a árvore.
 */
type UpdateContextValue = {
  modalUpdateNaTela: boolean;
  setModalUpdateNaTela: (value: boolean) => void;
};

export const UpdateContext = createContext<UpdateContextValue>({
  modalUpdateNaTela: false,
  setModalUpdateNaTela: () => {},
});

export const UpdateProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [modalUpdateNaTela, setModalUpdateNaTela] = useState(false);
  // value memoizado: só muda quando o flag muda (evita re-render por identidade nova).
  const value = useMemo(() => ({ modalUpdateNaTela, setModalUpdateNaTela }), [modalUpdateNaTela]);
  return <UpdateContext.Provider value={value}>{children}</UpdateContext.Provider>;
};

export const useUpdateModalState = () => useContext(UpdateContext);
